import axios from 'axios';
import v2 from '../v2';

export interface IParkingLotAmendMentPoint {
  inParkingLot: boolean;
  opType: number;
  order: string;
  region: string;
  stock: {
    id: string;
    lngLat: ILngLat;
  };
  time: number;
  user: {
    id: string;
    lngLat: ILngLat;
  };
  _id: string;
}

export const fetchData = async (region: string, date: number): Promise<IParkingLotAmendMentPoint[]> => {
  const { data } = await v2({
    url: '/record/parkingLotAmendment',
    params: {
      region,
      date,
    },
  });
  const result = await axios.get(data);
  return result.data;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/record/parkingLotAmendment.ts